/**
 * Dropdown options that map 1-to-1 with Apollo.io search API parameter values.
 * All string values are passed directly to the corresponding API fields.
 */

// person_seniorities[] — exact enum values from Apollo API
export const SENIORITY_OPTIONS = [
  { label: 'Owner', value: 'owner' },
  { label: 'Founder', value: 'founder' },
  { label: 'C-Suite', value: 'c_suite' },
  { label: 'Partner', value: 'partner' },
  { label: 'VP', value: 'vp' },
  { label: 'Head', value: 'head' },
  { label: 'Director', value: 'director' },
  { label: 'Manager', value: 'manager' },
  { label: 'Senior', value: 'senior' },
  { label: 'Entry', value: 'entry' },
  { label: 'Intern', value: 'intern' }
];

// person_departments[] — Apollo department filter values
export const DEPARTMENT_OPTIONS = [
  { label: 'Marketing', value: 'marketing' },
  { label: 'Sales', value: 'sales' },
  { label: 'Growth', value: 'growth' },
  { label: 'Business Development', value: 'business_development' },
  { label: 'Operations', value: 'operations' },
  { label: 'Engineering', value: 'engineering' },
  { label: 'Product', value: 'product_management' },
  { label: 'Design', value: 'design' },
  { label: 'Finance', value: 'finance' },
  { label: 'Human Resources', value: 'human_resources' },
  { label: 'Information Technology', value: 'information_technology' },
  { label: 'Customer Success', value: 'customer_success' }
];

// person_titles[] — free-text but these match Apollo's indexed titles
export const TITLE_OPTIONS = [
  { label: 'CEO', value: 'CEO' },
  { label: 'CTO', value: 'CTO' },
  { label: 'CFO', value: 'CFO' },
  { label: 'COO', value: 'COO' },
  { label: 'CMO', value: 'CMO' },
  { label: 'CPO', value: 'CPO' },
  { label: 'Founder', value: 'Founder' },
  { label: 'Co-Founder', value: 'Co-Founder' },
  { label: 'Managing Director', value: 'Managing Director' },
  { label: 'General Manager', value: 'General Manager' },
  { label: 'VP of Engineering', value: 'VP of Engineering' },
  { label: 'VP of Sales', value: 'VP of Sales' },
  { label: 'VP of Marketing', value: 'VP of Marketing' },
  { label: 'VP of Product', value: 'VP of Product' },
  { label: 'Head of Engineering', value: 'Head of Engineering' },
  { label: 'Head of Sales', value: 'Head of Sales' },
  { label: 'Head of Growth', value: 'Head of Growth' },
  { label: 'Head of Product', value: 'Head of Product' },
  { label: 'Director of Engineering', value: 'Director of Engineering' },
  { label: 'Director of Sales', value: 'Director of Sales' },
  { label: 'Product Manager', value: 'Product Manager' },
  { label: 'Engineering Manager', value: 'Engineering Manager' },
  { label: 'Software Engineer', value: 'Software Engineer' },
  { label: 'Full Stack Developer', value: 'Full Stack Developer' },
  { label: 'Frontend Developer', value: 'Frontend Developer' },
  { label: 'Backend Developer', value: 'Backend Developer' },
  { label: 'DevOps Engineer', value: 'DevOps Engineer' },
  { label: 'Data Scientist', value: 'Data Scientist' },
  { label: 'Data Analyst', value: 'Data Analyst' },
  { label: 'Marketing Manager', value: 'Marketing Manager' },
  { label: 'Sales Manager', value: 'Sales Manager' },
  { label: 'Business Development Manager', value: 'Business Development Manager' },
  { label: 'Operations Manager', value: 'Operations Manager' },
  { label: 'Finance Manager', value: 'Finance Manager' },
  { label: 'Account Executive', value: 'Account Executive' },
  { label: 'Sales Development Representative', value: 'Sales Development Representative' }
];

// organization_locations[] — free-text; countries/cities passed directly to Apollo
export const LOCATION_OPTIONS = [
  // Africa
  { label: 'Nigeria', value: 'Nigeria' },
  { label: 'Kenya', value: 'Kenya' },
  { label: 'Ghana', value: 'Ghana' },
  { label: 'South Africa', value: 'South Africa' },
  { label: 'Egypt', value: 'Egypt' },
  { label: 'Ethiopia', value: 'Ethiopia' },
  { label: 'Tanzania', value: 'Tanzania' },
  { label: 'Uganda', value: 'Uganda' },
  { label: 'Rwanda', value: 'Rwanda' },
  { label: 'Senegal', value: 'Senegal' },
  { label: "Côte d'Ivoire", value: "Côte d'Ivoire" },
  { label: 'Cameroon', value: 'Cameroon' },
  { label: 'Zambia', value: 'Zambia' },
  { label: 'Zimbabwe', value: 'Zimbabwe' },
  // Global hubs
  { label: 'United States', value: 'United States' },
  { label: 'United Kingdom', value: 'United Kingdom' },
  { label: 'Canada', value: 'Canada' },
  { label: 'India', value: 'India' },
  { label: 'Germany', value: 'Germany' },
  { label: 'France', value: 'France' },
  { label: 'Netherlands', value: 'Netherlands' },
  { label: 'Singapore', value: 'Singapore' },
  { label: 'Australia', value: 'Australia' }
];

// q_organization_keyword_tags[] — industry keywords Apollo indexes against companies
export const INDUSTRY_OPTIONS = [
  { label: 'Fintech', value: 'fintech' },
  { label: 'SaaS', value: 'saas' },
  { label: 'E-commerce', value: 'e-commerce' },
  { label: 'Healthtech', value: 'healthtech' },
  { label: 'Edtech', value: 'edtech' },
  { label: 'Logistics', value: 'logistics' },
  { label: 'Agritech', value: 'agritech' },
  { label: 'Proptech', value: 'proptech' },
  { label: 'Insurtech', value: 'insurtech' },
  { label: 'Legaltech', value: 'legaltech' },
  { label: 'HR Tech', value: 'hr tech' },
  { label: 'Payroll', value: 'payroll' },
  { label: 'Payments', value: 'payments' },
  { label: 'Banking', value: 'banking' },
  { label: 'Lending', value: 'lending' },
  { label: 'Insurance', value: 'insurance' },
  { label: 'Retail', value: 'retail' },
  { label: 'Media', value: 'media' },
  { label: 'Marketing', value: 'marketing' },
  { label: 'Consulting', value: 'consulting' },
  { label: 'Telecommunications', value: 'telecommunications' },
  { label: 'Energy', value: 'energy' },
  { label: 'Real Estate', value: 'real estate' },
  { label: 'Healthcare', value: 'healthcare' },
  { label: 'Manufacturing', value: 'manufacturing' },
  { label: 'Transportation', value: 'transportation' },
  { label: 'Food & Beverage', value: 'food and beverage' },
  { label: 'Travel & Hospitality', value: 'travel and hospitality' },
  { label: 'Cybersecurity', value: 'cybersecurity' },
  { label: 'Artificial Intelligence', value: 'artificial intelligence' },
  { label: 'Cloud Computing', value: 'cloud computing' },
  { label: 'Developer Tools', value: 'developer tools' }
];
